import styled from '@emotion/styled'

export const StyleFeatureCardGrid = styled.div`
  display: grid;
  place-content: center;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: auto;
  gap: 14px;
  width: 100%;
  padding: 30px 50px;
  & > :nth-of-type(3) {
    grid-row: span 2;
  }
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    & > :nth-of-type(3) {
      grid-row: auto;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    padding: 20px;

    & > :nth-of-type(3) {
      grid-row: auto;
    }
  }
  @media (max-width: 480px) {
    padding: 30px 0;
  }
`

export const StyleFeatureCard = styled.div<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor || '#f2efff'};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 12px 16px;
  justify-content: flex-start;
  width: 100%;
`
